"use strict";
import * as React from "react";
const SvgApi = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement(
  "circle",
  {
    style: {
      fill: "#fad24d"
    },
    cx: 256,
    cy: 256,
    r: 256
  }
), /* @__PURE__ */ React.createElement(
  "ellipse",
  {
    style: {
      fill: "#edb937"
    },
    cx: 256,
    cy: 421.64,
    rx: 182.28,
    ry: 14.369
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#666"
    },
    d: "M65.982 67.222h380.036c12.486 0 22.7 10.217 22.7 22.703V324.03H43.282V89.925c0-12.486 10.214-22.703 22.7-22.703z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#15bdb2"
    },
    d: "M58.695 308.614h394.607V89.922c0-3.979-3.308-7.287-7.287-7.287H65.979c-3.976 0-7.287 3.308-7.287 7.287v218.693l.003-.001z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#fff"
    },
    d: "M468.718 324.03v24.826c0 12.489-11.261 22.703-25.026 22.703H68.305c-13.765 0-25.026-10.214-25.026-22.703V324.03H468.718zM144.153 234.3H131.29l-2.201-14.717h-15.643l-2.201 14.717H99.54l12.979-81.119h18.657l12.979 81.119h-.002zm-29.089-25.727h12.284l-6.14-41.024-6.144 41.024zM168.837 153.181c6.413 0 11.182 1.7 14.314 5.099 3.129 3.399 4.693 8.384 4.693 14.951v10.544c0 6.568-1.563 11.549-4.693 14.949-3.129 3.399-7.901 5.099-14.314 5.099h-6.025v30.476h-12.748V153.18h18.773v.001zm-6.025 11.588v27.465h6.025c2.009 0 3.554-.54 4.635-1.624 1.081-1.081 1.621-3.09 1.621-6.025v-12.168c0-2.935-.54-4.944-1.621-6.025-1.083-1.081-2.628-1.621-4.635-1.621h-6.025v-.002zM193.75 153.181h12.748V234.3H193.75v-81.119zM367.541 206.507l4.024-15.339-9.107-3.575a54.953 54.953 0 0 0-.055-10.34l9.073-3.67-4.184-15.295-9.663 1.458a54.259 54.259 0 0 0-5.228-8.932l6.02-7.709-11.274-11.155-7.646 6.101a54.222 54.222 0 0 0-8.983-5.136l1.358-9.679-15.339-4.024-3.575 9.107a54.7 54.7 0 0 0-10.34.055l-3.667-9.073-15.297 4.184 1.458 9.663.005-.002a54.241 54.241 0 0 0-8.932 5.228l-7.709-6.022-11.155 11.274 6.101 7.646a54.14 54.14 0 0 0-5.136 8.983l-9.679-1.358-4.024 15.339 9.107 3.575a54.953 54.953 0 0 0 .055 10.34l-9.073 3.667 4.184 15.297 9.66-1.458a54.383 54.383 0 0 0 5.228 8.932l-6.02 7.709L269 233.453l7.646-6.101a54.02 54.02 0 0 0 8.983 5.136l-1.358 9.676 15.339 4.026 3.575-9.107c3.438.307 6.901.288 10.34-.055l3.67 9.073 15.295-4.184-1.458-9.66a54.259 54.259 0 0 0 8.932-5.228l7.709 6.02 11.155-11.271-6.101-7.646a54.02 54.02 0 0 0 5.136-8.983l9.678 1.358zm-41.701-6.225c-9.713 9.813-25.538 9.894-35.35.184-9.813-9.713-9.895-25.537-.184-35.35 9.713-9.813 25.538-9.894 35.35-.184 9.813 9.713 9.894 25.538.184 35.35z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#ecf0f1"
    },
    d: "M308.071 150.421c-17.826 0-32.279 14.45-32.279 32.279 0 17.826 14.451 32.279 32.279 32.279 17.826 0 32.279-14.451 32.279-32.279 0-17.826-14.45-32.279-32.279-32.279zm17.769 49.863c-9.713 9.813-25.538 9.894-35.35.184-9.813-9.712-9.895-25.537-.184-35.35 9.713-9.813 25.538-9.894 35.35-.184 9.813 9.713 9.894 25.538.184 35.35z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#fff"
    },
    d: "M417.06 242.49a25.926 25.926 0 0 0-.285-5.477l5.244-2.987-5.957-12.386-5.65 2.028a25.697 25.697 0 0 0-4.076-3.67l1.598-5.821-12.971-4.546-2.563 5.429a25.926 25.926 0 0 0-5.477.285l-2.986-5.241-12.386 5.959 2.028 5.647a25.843 25.843 0 0 0-3.67 4.076l-5.821-1.598-4.546 12.971 5.429 2.565a25.963 25.963 0 0 0 .283 5.474l-5.244 2.987 5.957 12.386 5.65-2.028a26.021 26.021 0 0 0 4.076 3.67l-1.595 5.821 12.971 4.546 2.563-5.432c1.812.1 3.649.008 5.477-.283l2.985 5.244 12.386-5.957-2.028-5.647a25.848 25.848 0 0 0 3.67-4.079l5.821 1.598 4.546-12.971-5.429-2.563zm-16.328 8.23c-5.309 5.367-13.963 5.408-19.329.1-5.363-5.31-5.408-13.963-.1-19.329 5.309-5.365 13.963-5.408 19.329-.1 5.365 5.311 5.409 13.962.1 19.329z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#ecf0f1"
    },
    d: "M391.016 221.639c-10.752 0-19.468 8.716-19.468 19.468s8.716 19.468 19.468 19.468 19.468-8.716 19.468-19.468-8.716-19.468-19.468-19.468zm9.714 29.081c-5.309 5.365-13.963 5.408-19.326.1-5.366-5.309-5.411-13.963-.103-19.326v-.003c5.312-5.367 13.963-5.411 19.329-.1 5.365 5.308 5.409 13.962.1 19.329z"
  }
), /* @__PURE__ */ React.createElement(
  "circle",
  {
    style: {
      fill: "#b6b6b8"
    },
    cx: 256,
    cy: 346.8,
    r: 7.814
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#c2c2c4"
    },
    d: "m305.065 407.271 36.095 11.564H170.836l29.123-11.564v-35.712h105.104v35.712h.002z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#b6b6b8"
    },
    d: "m305.065 407.271-105.104-35.712h105.104v35.712z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    style: {
      fill: "#ecf0f1"
    },
    d: "M199.959 407.271h105.104l36.095 11.564v4.981H170.834v-4.981l29.123-11.564h.002z"
  }
));
export default SvgApi;
